import "./Header.css";


const Header = () => {

return (
	
    <>
	<header>
		<div>
			<a href="https://www.pts.se/" target="_blank"><img src="https://dsa.pts.se/pts_logotyp_2024-singel_sv.svg" alt="Länk till startsidan på pts.se"  /></a>
		</div>
	</header>
	</>
		
)
}
export default  Header;